import { call, takeLatest } from 'redux-saga/effects';
import { fetchStatementAsync } from '@store/actions/statements.action';
import { ApiError, Documents, Statements } from '@types';
import { axiosApi } from '@utils/fetch';
import { put, select } from '@redux-saga/core/effects';
import { selectLenderDocuments, selectLenderLoanNumber } from '@store/selectors/statement.selector';
import { isArray, isEqual } from 'lodash';
import { setDocumentUrl } from '@store/actions/document.action';
import { config } from '../../config';
import { nanoid } from '@reduxjs/toolkit';

function* extracted(documents: Array<Documents>, uid: string | Array<string>, loanNumber: string) {
    const document = documents.find(document => (isArray(uid) ? uid.includes(document.nameUid) : document.nameUid === uid));
    if (document) {
        yield put(setDocumentUrl(document.url));
        yield put(fetchStatementAsync.failure(undefined, loanNumber));
        yield call(window.open, config.env('redirectUri') + '#/document');
    } else yield put(fetchStatementAsync.failure({ id: nanoid(16), message: '', status: 404 }, loanNumber));
}

export function* downloadStatementWorker(action: ReturnType<typeof fetchStatementAsync.request>) {
    const {
        payload: {
            metadata: { loanNumber, uid },
            ...requestConfig
        }
    } = action;

    const lenderLoan: string = yield select(selectLenderLoanNumber);
    const documents: Array<Documents> = yield select(selectLenderDocuments);

    if (isEqual(lenderLoan, loanNumber)) {
        yield call(extracted, documents, uid, loanNumber);
        return;
    }

    const { response, error }: { response: Statements; error: ApiError } = yield call(axiosApi, requestConfig);
    if (response) {
        yield put(fetchStatementAsync.success(response, loanNumber));
        yield call(extracted, response.documents, uid, loanNumber);
    }
    if (error) {
        yield put(fetchStatementAsync.failure(error, loanNumber));
    }
}
export default function* root() {
    yield takeLatest(fetchStatementAsync.request, downloadStatementWorker);
}
